<template>
  <div class="border rounded">
    <div class="tiptap">
      <editor-content :editor="editor" />
    </div>
    <div v-if="editor" class="border-top p-1">
      <CButton color="info" variant="outline" size="sm" @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
        B
      </CButton>
      <CButton color="info" variant="outline" size="sm" class="ml-2" @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">
        <em>I</em>
      </CButton>
    </div>
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'

const CustomBold = Bold.extend({
  renderHTML({ HTMLAttributes }) {
    return ['b', HTMLAttributes, 0]
  },
})

const CustomItalic = Italic.extend({
  renderHTML({ HTMLAttributes }) {
    return ['i', HTMLAttributes, 0]
  },
})

export default {
  components: {
    EditorContent,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editor: null,
    }
  },

  watch: {
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      if (isSame) {
        return
      }

      this.editor.commands.setContent(this.value, false)
    },
  },

  mounted() {
    this.editor = new Editor({
      extensions: [
        Document,
        Paragraph,
        Text,
        CustomBold,
        CustomItalic,
      ],
      content: this.value,
      onUpdate: () => {
        // HTML
        this.$emit('input', this.editor.getHTML())
      },
    })
  },

  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>


<style>
  .tiptap {
    padding:  6px;
  }
  .is-active {
    background-color: #0D86FF !important;
    color:  white;
  }
</style>
